import { Badge, Button, Table, Text } from "@mantine/core";
import type { ApiKey } from "../../services/api";
import { toExactTime, toRelativeTime } from "../../utils/activity";

interface ApiKeyTableProps {
	apiKeys: ApiKey[];
	onSetActive: (apiKey: ApiKey, isActive: boolean) => void;
}

function ApiKeyTable({ apiKeys, onSetActive }: ApiKeyTableProps) {
	return (
		<Table.ScrollContainer minWidth={600}>
			<Table
				striped
				highlightOnHover>
				<Table.Thead>
					<Table.Tr>
						<Table.Th>Name</Table.Th>
						<Table.Th>Key</Table.Th>
						<Table.Th>Status</Table.Th>
						<Table.Th>Last used</Table.Th>
						<Table.Th>Created</Table.Th>
						<Table.Th />
					</Table.Tr>
				</Table.Thead>
				<Table.Tbody>
					{apiKeys.map((apiKey) => (
						<Table.Tr key={apiKey._id}>
							<Table.Td>
								<Text fw={500}>{apiKey.name}</Text>
							</Table.Td>
							<Table.Td>
								<Text
									ff="monospace"
									size="sm">
									••••{apiKey.hint}
								</Text>
							</Table.Td>
							<Table.Td>
								<Badge
									color={apiKey.isActive ? "green" : "gray"}
									variant="light">
									{apiKey.isActive ? "Active" : "Inactive"}
								</Badge>
							</Table.Td>
							<Table.Td title={apiKey.lastUsedAt ? toExactTime(apiKey.lastUsedAt) : undefined}>
								{apiKey.lastUsedAt ? toRelativeTime(apiKey.lastUsedAt) : "Never"}
							</Table.Td>
							<Table.Td>
								<Text size="sm">{toExactTime(apiKey.createdAt)}</Text>
								<Text
									size="xs"
									c="dimmed">
									{apiKey.createdBy?.username ?? "From SPACEOS_API_KEY"}
								</Text>
							</Table.Td>
							<Table.Td>
								<Button
									size="xs"
									variant="light"
									color={apiKey.isActive ? "red" : "green"}
									onClick={() => onSetActive(apiKey, !apiKey.isActive)}>
									{apiKey.isActive ? "Deactivate" : "Activate"}
								</Button>
							</Table.Td>
						</Table.Tr>
					))}
				</Table.Tbody>
			</Table>
		</Table.ScrollContainer>
	);
}

export default ApiKeyTable;
